module.exports = "<button class=\"btn btn-primary btn-action-bar convertToPDFBtn\" title=\"scarica pdf\"><span class=\"icon-file-pdf\"></span></button>";